import { render } from "./mrf_transparency_panel.vue?vue&type=template&id=51a39ce5"
import script from "./mrf_transparency_panel.js?vue&type=script&lang=js"
export * from "./mrf_transparency_panel.js?vue&type=script&lang=js"

import "./mrf_transparency_panel.vue?vue&type=style&index=0&id=51a39ce5&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__